import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { getTextColorsFromSection } from '../lib/colors';
import Section from '../Section';
import TypographyDraft from '../TypographyDraft';

function getImageClasses(classes, imageStyle) {
  return classNames(
    classes.image,
    imageStyle === 'circle' && classes.imageCircle,
    imageStyle === 'rounded' && classes.imageRounded,
  );
}

function PersonSection({ classes, event, site, section }) {
  const { data, styles } = section;
  const colors = getTextColorsFromSection(site, section);
  return (
    <Section
      site={site}
      section={section}
      className={classNames(classes.root, !data.description && classes.noContent)}
      withPadding
    >
      {data.description && (
        <section className={classes.content}>
          {data.title && (
            <TypographyDraft
              component="h2"
              style={{ ...colors.title, ...styles.title }}
              data={data.title}
            />
          )}
          {data.description && (
            <TypographyDraft
              className={classes.description}
              style={{ ...colors.text, ...styles.description }}
              data={data.description}
            />
          )}
          <div
            className={classNames(
              classes.personInfoInContent,
              !data.image && classes.personInfoInContentNoImage,
            )}
          >
            <TypographyDraft
              component="h3"
              style={{ ...colors.text, ...styles.name }}
              className={classNames(classes.name, classes.guestNameAlignment)}
              data={data.name}
            />

            {data.name.blocks &&
              data.name.blocks[0].text &&
              data.subtitle.blocks &&
              data.subtitle.blocks[0].text && (
                <div style={{ ...colors.text, ...styles.name }} className={classes.separator} />
              )}
            <TypographyDraft
              style={{ ...colors.text, ...styles.subtitle }}
              data={data.subtitle}
              className={classes.guestNameAlignment}
            />
          </div>
        </section>
      )}
      {data.image && (
        <div
          className={classNames(
            classes.imageWrapper,
            !data.description && classes.imageWrapperNoContent,
          )}
        >
          {/* TODO alt intl */}
          {data.title && !data.description && (
            <TypographyDraft
              component="h2"
              style={{ ...colors.title, ...styles.title }}
              className={classes.titleNoDescription}
              data={data.title}
            />
          )}
          <img
            alt=""
            src={data.image && data.image.url}
            className={getImageClasses(classes, styles.imageStyle)}
            style={styles.image}
          />
          <div
            className={classNames(
              classes.personInfoInImage,
              !data.description && classes.personInfoInImageNoContent,
            )}
          >
            <TypographyDraft
              component="h3"
              style={{ ...colors.text, ...styles.name }}
              data={data.name}
            />

            <TypographyDraft style={{ ...colors.text, ...styles.subtitle }} data={data.subtitle} />
          </div>
        </div>
      )}
    </Section>
  );
}

PersonSection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  noContent: {
    justifyContent: 'center',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  titleNoDescription: {
    marginBottom: 2 * theme.spacing.unit,
  },
  description: {
    marginTop: 3 * theme.spacing.unit,
  },
  personInfoInContent: {
    display: 'flex',
    marginTop: 3 * theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  personInfoInContentNoImage: {
    display: 'inherit',
  },
  personInfoInImage: {
    marginTop: 3 * theme.spacing.unit,
    marginLeft: 2 * theme.spacing.unit,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  personInfoInImageNoContent: {
    display: 'inherit',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 3 * theme.spacing.unit,
    marginLeft: 0,
  },
  separator: {
    border: 'solid 1px',
    margin: `0 ${theme.spacing.unit}px`,
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing.large,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: 3 * theme.spacing.unit,
      justifyContent: 'start',
    },
  },
  imageWrapperNoContent: {
    flexDirection: 'column',
    marginLeft: 0,
  },
  image: {
    width: 260,
    height: 260,
    [theme.breakpoints.down('md')]: {
      width: 180,
      height: 180,
    },
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 100,
    },
  },
  imageCircle: {
    borderRadius: '50%',
  },
  imageRounded: {
    borderRadius: 16,
  },
  guestNameAlignment: {
    alignSelf: 'center',
  },
});

export default injectSheet(stylesheet)(PersonSection);



// WEBPACK FOOTER //
// ./src/site-render/src/PersonSection/PersonSection.js